import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import cloneDeep from "core-web/utils/cloneDeep";

class VariantSelectorContainer extends Component {
    combinations = {};

    static propTypes = {
        callback: PropTypes.func.isRequired,
        getSelectedParametrics: PropTypes.func,
        location: PropTypes.object.isRequired,
        productId: PropTypes.number.isRequired,
        render: PropTypes.func.isRequired,
        selectedVariant: PropTypes.object,
        setVariantParametrics: PropTypes.func,
        t: PropTypes.func.isRequired,
        variants: PropTypes.array.isRequired,
    };

    static defaultProps = {
        getSelectedParametrics: () => null,
        selectedVariant: null,
        setVariantParametrics: () => null,
    };

    constructor(props) {
        super(props);
        this.state = this.setupState(this.props.variants);
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (
            this.props.productId !== nextProps.productId ||
            JSON.stringify(this.props.variants) !== JSON.stringify(nextProps.variants) ||
            (this.props.selectedVariant &&
                JSON.stringify(this.props.selectedVariant) !== JSON.stringify(nextProps.selectedVariant) &&
                JSON.stringify(this.props.selectedVariant) ===
                    JSON.stringify(this.getVariantByParametricSelection(nextState.selectedParametrics)))
        ) {
            this.setState({ ...this.setupState(nextProps.variants) });
            return false;
        }
        return JSON.stringify(this.state) !== JSON.stringify(nextState);
    }

    setupState = (variants) => {
        if (variants?.length === 0) {
            return {};
        }

        const { selectedVariant, getSelectedParametrics } = this.props;
        const combinations = {};
        const selections = [];
        const selectedParametrics = [];

        if (variants?.length) {
            variants.forEach((variant, variantIndex) => {
                variant.variant_parametrics.forEach((parametric, parametricIndex) => {
                    let variantValues = {
                        label: parametric.value,
                        value: parametric.value_2,
                        amountValue: parametric?.amount_value || false,
                    };
                    if (parametric.code === "color") {
                        variantValues = { ...variantValues, id: parametric.value_id };
                    }
                    if (parametric.code === "variant_value") {
                        variantValues = { ...variantValues, name: this.props.t("pdp.size") };
                    }
                    if (variantIndex === 0) {
                        selections.push({
                            id: parametric.id,
                            name: parametric.name,
                            code: parametric.code,
                            values: [variantValues],
                        });

                        selectedParametrics.push({
                            id: parametric.id,
                            value: false,
                            name: parametric.code === "variant_value" ? this.props.t("pdp.size") : parametric.name,
                            code: parametric.code,
                        });
                    } else {
                        let selectionMatch = false;
                        selections.forEach((selection) => {
                            if (selection.id === parametric.id) {
                                selectionMatch = selection;
                            }
                        });
                        if (selectionMatch) {
                            if (selectionMatch.values.indexOf(parametric.value_2) === -1) {
                                selectionMatch.values.push(variantValues);
                            }
                        }
                    }
                    const colorValue = this.props.location.state?.colorValue;
                    if (selectedParametrics[parametricIndex]) {
                        if (selectedVariant && selectedVariant.id === variant.id) {
                            selectedParametrics[parametricIndex].value = parametric.value_2;
                        } else if (colorValue && parametric.code === "color") {
                            selectedParametrics[parametricIndex].value = colorValue;
                        }
                    }
                });
                combinations[
                    variant.variant_parametrics.map((parametric) => `${parametric.id}|${parametric.value_2}`).join("--")
                ] = variant;
            });
        }

        this.combinations = combinations;

        if (selectedParametrics.every((parametric) => !!parametric.value)) {
            const variant = this.getVariantByParametricSelection(selectedParametrics);
            if (variant) {
                setTimeout(() => {
                    this.props.callback(this.props.productId, variant);
                });
            } else {
                this.props.setVariantParametrics(selectedParametrics);
            }
        } else {
            this.props.setVariantParametrics(selectedParametrics);
        }

        getSelectedParametrics(selectedParametrics);

        return {
            selections,
            selectedParametrics,
        };
    };

    static defaultState = {
        selections: [],
        selectedParametrics: [],
    };

    selectParametricValue = (parametricIndex, parametricValue) => {
        const { productId, callback, getSelectedParametrics } = this.props;
        const { selectedParametrics } = this.state;
        let isValidCombination = true;

        const newSelectedParametrics = cloneDeep(selectedParametrics);

        newSelectedParametrics.forEach((parametric, stateIndex) => {
            if (stateIndex === parametricIndex) {
                parametric.value = parametricValue;
            } else {
                if (isValidCombination) {
                    // This is just here to prevent it from running if a parent has no value
                    const isCurrentIndexAValidCombination = this.checkPossibleSelection(
                        stateIndex,
                        parametric.id,
                        parametric.value,
                        newSelectedParametrics,
                    );

                    if (!isCurrentIndexAValidCombination) {
                        parametric.value = false;
                        isValidCombination = false;
                    }
                } else {
                    parametric.value = false;
                }
            }
        });

        getSelectedParametrics(newSelectedParametrics);

        this.setState({ selectedParametrics: newSelectedParametrics }, () => {
            const variantByParametricCombination = this.getVariantByParametricSelection();
            callback(productId, variantByParametricCombination);
        });
    };

    getVariantByParametricSelection = (selectedParametricState = this.state.selectedParametrics) => {
        let variant = null;

        const combination = selectedParametricState
            .map((parametric) => {
                return `${parametric.id}|${parametric.value}`;
            })
            .join("--");

        if (combination && this.combinations[combination]) {
            variant = this.combinations[combination];
        }

        return variant;
    };

    checkPossibleSelection = (
        parametricIndex,
        parametricId,
        parametricValue,
        selectedParametrics = this.state.selectedParametrics,
    ) => {
        const combinationPart = [];
        selectedParametrics.forEach((parametric, index) => {
            if (parametricIndex > index && parametric.value) {
                combinationPart.push(parametric);
            } else if (parametricIndex === index) {
                combinationPart.push({ id: parametricId, value: parametricValue });
            }
        });

        const validCombinations = Object.keys(this.combinations).filter((combination) => {
            const splitCombination = combination.split("--");
            return combinationPart.every(({ id, value }) =>
                splitCombination.some((singleCombination) => singleCombination === `${id}|${value}`),
            );
        });

        return validCombinations.length;
    };

    checkStockStatus = (
        parametricIndex,
        parametricId,
        parametricValue,
        selectedParametrics = this.state.selectedParametrics,
    ) => {
        const combinationPart = [];
        const currentSelections = this.state.selections;
        let currentIndexHasSelection = false;

        if (currentSelections[parametricIndex]?.selectedValue) {
            currentIndexHasSelection = true;
        }

        selectedParametrics.forEach((parametric, index) => {
            if (parametricIndex > index && parametric.value) {
                combinationPart.push(parametric);
            } else if (parametricIndex === index) {
                combinationPart.push({ id: parametricId, value: parametricValue });
            }
        });

        const validCombinations = Object.keys(this.combinations).filter((combination) => {
            const splitCombination = combination.split("--");
            return combinationPart.every(({ id, value }) =>
                splitCombination.some((singleCombination) => singleCombination === `${id}|${value}`),
            );
        });

        const validCombinationsWithStock = validCombinations.filter((combination) => {
            return (
                (this.combinations[combination].on_hand.value && this.combinations[combination].on_hand.value > 0) ||
                (this.combinations[combination].on_hand_stock && this.combinations[combination].on_hand_stock.value > 0)
            );
        });

        if (Object.values(selectedParametrics).length > 1) {
            const splitValues = validCombinationsWithStock.map((combination) =>
                combination.split("--").map((sub) => {
                    return sub.split("|")[1];
                }),
            );

            if (selectedParametrics.some((parametric) => parametric.value)) {
                const match = splitValues.every((value) =>
                    Object.values(selectedParametrics).every((parametric) => !value.includes(parametric.value)),
                ).length;
                if (match && !currentIndexHasSelection) {
                    return false;
                }
            }
        }

        return !!validCombinationsWithStock.length;
    };

    render() {
        const { render: Renderer, variants } = this.props;
        const { selectedParametrics, selections } = this.state;

        if (!variants?.length) {
            return null;
        }

        return Renderer ? (
            <Renderer
                variants={variants}
                selections={selections}
                selectedParametrics={selectedParametrics}
                selectParametricValue={this.selectParametricValue}
                checkStockStatus={this.checkStockStatus}
                checkPossibleSelection={this.checkPossibleSelection}
                getVariantByParametricSelection={this.getVariantByParametricSelection}
            />
        ) : null;
    }
}

export default withRouter(withTranslation()(VariantSelectorContainer));
